import { useQuery } from '@pinia/colada';
import { computed } from 'vue';

import { PropertyStatus } from '@tallo/property';

import propertyService from '../services/property.service';

export const portfolioQueryKey = 'portfolio';

export function usePortfolioQuery() {
  const { state, data, ...rest } = useQuery({
    key: () => [portfolioQueryKey],
    query: () => propertyService.getPortfolio(1, 100),
  });

  const properties = computed(() => data.value?.properties || []);
  const hasActiveProperties = computed(() => {
    const activeProperties = properties.value.filter((property) => property.status !== PropertyStatus.DRAFT);

    return activeProperties.length > 0;
  });

  return {
    ...rest,
    state,
    data,
    properties,
    hasActiveProperties,
  };
}
